<template>
  <div class="agent">
    <div class="title">
      代理人概要
    </div>

    <div class="filter">
      <el-row>
        <el-col :span="24">
          <el-cascader
            v-if="isDepartment"
            v-model="departmentID"
            filterable
            placeholder="組別"
            class="w150"
            :show-all-levels="false"
            :options="departmentList"
            :props="{
              checkStrictly: true,
              children: 'childNode',
              value: 'departmentID',
              label: 'departmentName',
              emitPath: false
            }"
          />
          <el-select
            v-model="status"
            class="w120"
            placeholder="狀態"
          >
            <!-- <el-option label="全部" value></el-option> -->
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="danger"
            @click="clickSearch"
          >
            查詢
          </el-button>
          <el-button
            type="info"
            @click="resetSearch"
          >
            重置
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div class="line" />

    <div class="table">
      <!-- 文字列表 -->
      <div class="text-list">
        <el-table
          v-loading="firstLoading"
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
          :data="agentList"
          empty-text="暫無數據"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="name"
            label="代理人"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            label="照片"
            width="150"
          >
            <template slot-scope="scope">
              <div class="img1">
                <img
                  :src="pub.imgResize(scope.row.imagePath, 'user')"
                  onerror="errorImg(this,'user')"
                  alt
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="telephone"
            label="電話"
            width="120"
          />
          <el-table-column
            prop="email"
            label="電郵"
            min-width="200"
          />
          <el-table-column
            label="牌照"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.license ? scope.row.license : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="賬戶狀態"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.status == 'Disable' ? '停用' : '啟用' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="propertyNumber"
            label="個人放盤數量"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                class="btn-a"
                type="text"
                @click="clickPropertyNumber(scope.row.accountID,2)"
              >
                {{ scope.row.propertyNumber }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="agentPropertyNumber"
            label="代理樓盤數量"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                class="btn-a"
                type="text"
                @click="clickPropertyNumber(scope.row.accountID,1)"
              >
                {{ scope.row.agentPropertyNumber }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            min-width="200"
            label="署名及特別服務"
          >
            <template slot-scope="scope">
              <div class="h45">
                <span
                  class="signature"
                  :title="scope.row.signature"
                >
                  {{ scope.row.signature ? scope.row.signature : '-' }}
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 圖片列表 -->

      <div class="footer">
        <el-pagination
          class="page"
          background
          :page-size="pageCount"
          :page-sizes="[10, 20, 50, 100]"
          layout="total,sizes,prev, pager, next,jumper"
          :current-page="pageIndex"
          :total="count"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Agent',
    data() {
        return {
            firstLoading: true,
            isDepartment: false,
            departmentList: [],
            departmentID: '',
            userInfo: [],
            agentList: [],
            count: 0,
            pageIndex: 1,
            pageCount: 10,
            status: '',
            statusList: [{ value: '', name: '全部' }, { value: 'Disable', name: '停用' }, { value: 'Normal', name: '啟用' }]
        };
    },
    created() {
        this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID,'agentPageCount') || 10
        /**获取登录用户信息 */
        this.axios.get(this.pub.getApi().GetCompanyUserInfo).then(res => {
            if (res.data.code === 0 && res.data.result) {
                this.userInfo = res.data.result;
                //获取组织
                this.loadTreeDepartments();
                this.loadGetPermission();
                if(this.userInfo.roleID == '1' || this.userInfo.roleID == '2'){
                    this.$confirm(`<div style="font-weight:700;color:#444444;margin-bottom:23px">[代理人概要]功能合併至[員工管理]</div>爲了提供更流暢使用體驗，[代理人概要]的功能已整合到[員工管理]，你可以在這裏找到所有熟悉的功能。`,  '提示',{
                        confirmButtonText: '點擊前往',
                        showCancelButton: false,
                        customClass: 'mesagent',
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                    }).then(() => {
                        this.$router.push({ path: '/staffing/index' });
                    })
                }
            }
        });
        //首次加载数据
        this.loadAgentList(true);
    },
    mounted() {},
    methods: {
        /**判断权限 */
        loadGetPermission() {
            this.axios
                .post(this.pub.getApi().GetPermissionByRoleId, {
                    roleID: this.userInfo.roleID
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        res.data.result.forEach(item => {
                            if (
                                /**是否是超级管理员 */
                                item.permissionsCode === 'Property_PropertyManage_Manager_All'
                            ) {
                                this.isDepartment = true;
                            } else if (item.permissionsCode === 'Property_PropertyManage_ExamineList_All') {
                                this.isDepartment = true;
                            }
                        });
                    }
                });
        },
        /**點擊禁用樓盤管理頁面 */
        clickPropertyNumber(accountID,type) {
            this.$router.push({
                name: this.pub.routeNameLists.AgentProperty,
                query: {
                    accountid: accountID,
                    searchAccountPropertyType:type
                }
            });
        },
        /**改变每页数据 */
        sizeChange(data) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'agentPageCount',data)
            this.pageCount = data;
            this.loadAgentList();
        },
        //获取组织
        loadTreeDepartments() {
            this.axios
                .get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                    params: { departmentID: this.userInfo.departmentID }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.departmentList.push(res.data.result);
                    }
                });
        },
        /**點擊搜索 */
        clickSearch() {
            this.pageIndex = 1;
            this.loadAgentList();
        },
        /**重置搜索 */
        resetSearch() {
            this.status = '';
            this.departmentID = '';
            this.clickSearch();
        },
        loadAgentList(first) {
            const data = this.getSearchValue();
            this.axios.post(this.pub.getApi().SearchDistinctOrganizationUserInfo, data).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.agentList = res.data.result.data;
                    this.count = res.data.result.count;
                    if (first) {this.firstLoading = false;}
                }
            });
        },
        /**獲取搜索數據 */
        getSearchValue() {
            const data = {};
            data.pageIndex = this.pageIndex;
            data.pageCount = this.pageCount;
            data.isAgentPage = true;
            if (this.status) {data.status = this.status;}
            if (this.departmentID) {data.departmentID = this.departmentID;}
            return data;
        },
        /**切換展示  圖文--列表*/
        handleSelectionChange() {},
        /**頁面大小調整 */
        handleChange() {
            const _this = this;
            clearTimeout(this.timeId);
            this.timeId = setTimeout(function() {
                _this.loadAgentList();
            }, 1000);
        },
        /**分頁 */
        currentChange(pageIndex) {
            this.pageIndex = pageIndex;
            this.loadAgentList();
        }
    }
};
</script>

<style lang="less">
// 调整按钮默认样式
.el-button--danger {
    background: #e50113;
}
.el-button--info {
    background: #bbbbbb;
    border: 1px solid #bbb;
}
.agent {
    /* 按钮样式 */
    .el-button {
        height: 38px;
        width: 95px;
    }

    .h45 {
        overflow: hidden;
        height: 45px;
    }
    background-color: #f3f3f5;
    padding: 0;
    margin: 0;
    text-align: left;
    .title {
        padding: 0 0 20px 0;
        font-size: 24px;
        color: #171725;
        .span {
            padding-left: 20px;
            font-size: 12px;
            color: #0062ff;
        }
    }
    .filter {
        padding-bottom: 16px;
        input {
            border: none;
            border-radius: 10px;
            height: 38px;
        }
        button {
            border-radius: 10px;
            width: 88px;
            height: 38px;
        }
        .w150,
        .w120 {
            margin-right: 18px;
            margin-bottom: 12px;
        }
        .w150 {
            width: 150px;
        }
        .w120 {
            width: 120px;
        }
        span.time {
            font-size: 14px;
            color: #696974;
        }
    }
    .line {
        width: 100%;
        height: 1px;
        background-color: #e2e2ea;
    }
    .button {
        padding: 30px 0 18px 0;
        button {
            width: 100px;
            border-radius: 10px;
            color: #bbb;
        }
        button:active {
            color: #fff;
            background-color: #0062ff;
        }
        .w40 {
            width: 40px;
            text-align: center;
        }
        .r-btn {
            display: inline-block;
            float: right;
            div {
                line-height: 38px;
                text-align: center;
                width: 38px;
                height: 38px;
                float: left;
                color: #92929d;
                background-color: #fff;
            }
            .r-btn1 {
                border-radius: 10px;
                margin-right: 18px;
            }
            .r-btn2 {
                border-radius: 10px 0 0 10px;
            }
            .r-btn3 {
                border-radius: 0 10px 10px 0px;
            }
            .r-btn1:active,
            .r-btn2:active,
            .r-btn3:active {
                color: #fff;
                background-color: #b5b5be;
            }
            .active {
                color: #fff;
                background-color: #b5b5be;
            }
        }
    }
    .table {
        .el-button {
            text-align: left;
            width: 100%;
        }
        margin-top: 28px;
        .btn-a {
            color: #0062ff;
        }
        table,
        tr,
        td,
        th {
            border: none;
        }
        .el-table tbody tr:hover > td {
            background-color: rgba(80, 181, 255, 0.1) !important;
        }
        /deep/ .el-table thead tr {
            th:first-child {
                border-radius: 10px 0 0 10px;
            }
            th:nth-last-child(2) {
                border-radius: 0 10px 10px 0;
            }
        }
        .el-table__header tr,
        .el-table__header th {
            padding: 0;
            height: 38px;
        }
        .el-table th {
            border: none;
        }
        .el-table td {
            border-bottom: 1px solid #e2e2ea;
        }
        table {
            color: #222;
            font-size: 14px;
            tr th .cell {
                font-weight: normal;
                font-size: 12px;
                color: #44444f;
            }
        }
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;
        .text-list {
            .img1 {
                width: 50px;
            }
            img {
                background-image: url('../../assets/user-default.png');
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
            .signature {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
            }
        }
        .footer {
            span {
                font-size: 14px;
                color: #44444f;

                margin-left: 16px;
            }
            margin-top: 16px;
            // border-top: 1px solid #e2e2ea;
            padding-top: 20px;
            box-sizing: border-box;
            height: 72px;
            .page {
                float: right;
            }
            .input-number {
                text-align: left;
                float: right;
                width: 70px;
            }
            /**覆盖计数器样式 */
            .el-input-number.is-controls-right .el-input__inner {
                padding-left: 8px;
                padding-right: 42px;
            }
        }
    }
}
.el-table .cell.el-tooltip {
    white-space: normal;
}
</style>
